import BaseView from 'components-framework/view/base.view';
import {dispatch} from 'od-modules/secure_store/store';
import {updateMembership} from 'od-modules/secure_store/reducers/asyncActionCreators';
const {revampTrackingLabel} = require('od-modules/utils/membership_tracking.utils').default;
const actions = require('od-modules/secure_store/actions');

const View = BaseView.extend({
    initialize() {
        this.listenTo(this.model, 'change:isExpiringCard', this.renderMessage);
        this.listenTo(this.model, 'change:pricing', this.updateWarningMessage);
    },

    renderMessage() {
        return this.model.get('isExpiringCard') ? this.renderWarningMessage() : this.removeWarningMessage();
    },

    updateWarningMessage() {
        this.model.get('isExpiringCard') && this.renderWarningMessage();
    },

    renderWarningMessage() {
        const {totalPrice} = this.model.get('pricing');
        this.keys.warningDescriptionWithFullPrice = Odigeo.Utils.replaceCmsKeyArgs(this.keys.warningDescription, totalPrice.toFixed(2));
        const warningMessageTemplate = Odigeo.AB.isCobaltDesktopForms ? 'warningMessageCobalt' : 'warningMessage';

        this.$el.html(this.templates[warningMessageTemplate]({keys: this.keys}));
        if (this.isSubscriptionAdded()) {
            return Odigeo.Utils.isMobile() ? this.editPrime(false) : Odigeo.trigger(`${this.id}:blockingBinDetected`);
        }
    },

    removeWarningMessage() {
        this.$el.html('');
        if (!this.isSubscriptionAdded()) {
            return Odigeo.Utils.isMobile() ? this.editPrime(true) : Odigeo.trigger(`${this.id}:blockingBinCleared`);
        }
    },

    isSubscriptionAdded() {
        const primeMemberSelected = this.model.get('primeMemberSelected');
        return primeMemberSelected && primeMemberSelected.isSubscriptionAdded;
    },

    getPrimeMemberSelectedUpdateDispatch(isAdd) {
        return {
            type: actions.SET_PRIME_MEMBER_SELECTED,
            entry: {
                isAddedInPayment: isAdd,
                isSubscriptionAdded: isAdd,
                ccStatus: isAdd ? 'validated' : 'invalid',
            },
            merge: true,
        };
    },

    editPrime(isAdd) {
        dispatch(this.getPrimeMemberSelectedUpdateDispatch(isAdd));
        dispatch(updateMembership);
        revampTrackingLabel('addPrimeCCEvaluation');
        if (!isAdd) {
            this.scrollToWarningMessage();
        }
    },

    scrollToWarningMessage() {
        Odigeo.Utils.scrollToElement(this.$el);
    },
});

export default View;
